import './base-layout.css';
import React, { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import globalConfigStore from '../../../stores/global-config-store';
import { UserType } from '../../../api/types/user/user-type';
import { AppBreadcrumbs } from '../../../components/breadcrumbs/app-breadcrumbs';
import globalUserProfile from '../../../stores/global-user-profile';
import { administrationComponent } from './compoenents/administration-component';
import { SideBarByRole } from './side-bars/side-bar-by-role';
import { observer } from 'mobx-react-lite';
import { UnauthorizedContent } from '../../unauthorized/unauthorized-content';

interface BaseLayoutProps {
  showUnauthorized?: boolean;
}

const BaseLayout: React.FC<BaseLayoutProps> = observer(
  ({ showUnauthorized = false }) => {
    const location = useLocation();
    const { branchId, programId, courseId } = useParams();

    useEffect(() => {
      // Only fetch data if we're not on the login page
      // For password change page, we still need to fetch profile
      if (location.pathname !== '/login') {
        const fetchData = async () => {
          try {
            await globalUserProfile.getUserProfile();
            globalConfigStore.isReady = true;
          } catch (error) {
            // Handle any errors here if needed
            console.error('Error fetching home data:', error);
          }
        };
        fetchData();
      }
    }, [location.pathname]);

    const isLoginOrPasswordChange =
      location.pathname === '/login' ||
      location.pathname === '/change-password-required';

    return (
      <div className={'base-layout-root'}>
        {!isLoginOrPasswordChange && globalUserProfile?.userType && (
          <SideBarByRole userType={globalUserProfile.userType} />
        )}

        <div style={{ flex: 1, minWidth: 0 }}>
          {!isLoginOrPasswordChange && <AppBreadcrumbs />}
          <div>
            {showUnauthorized ? (
              <UnauthorizedContent />
            ) : (
              administrationComponent(location, branchId, programId, courseId)
            )}
          </div>
        </div>
      </div>
    );
  },
);

export default BaseLayout;
